module.exports = __webpack_public_path__ + "static/media/chevron-double-down.eec06263.svg";